var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconStarsGeneric(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 130 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFB400"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5l3.09 6.26 6.91 1-5 4.87 1.18 6.87L12 17.27 5.82 20.5 7 13.63l-5-4.87 6.91-1L12 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 1.5l3.09 6.26 6.91 1-5 4.87 1.18 6.87L38 17.27l-6.18 3.23L33 13.63l-5-4.87 6.91-1L38 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 1.5l3.09 6.26 6.91 1-5 4.87 1.18 6.87L64 17.27l-6.18 3.23L59 13.63l-5-4.87 6.91-1L64 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 1.5l3.09 6.26 6.91 1-5 4.87 1.18 6.87L90 17.27l-6.18 3.23L85 13.63l-5-4.87 6.91-1L90 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116 1.5l3.09 6.26 6.91 1-5 4.87 1.18 6.87L116 17.27l-6.18 3.23L111 13.63l-5-4.87 6.91-1L116 1.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStarsGeneric);
export default __webpack_public_path__ + "static/media/icon_stars_generic.06b7196ea66aefc17432f97cddcfb470.svg";
export { ForwardRef as ReactComponent };